import { render } from "./AsideMenu.vue?vue&type=template&id=5470e910&scoped=true"
import script from "./AsideMenu.vue?vue&type=script&lang=js"
export * from "./AsideMenu.vue?vue&type=script&lang=js"

import "./AsideMenu.vue?vue&type=style&index=0&id=5470e910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5470e910"]])

export default __exports__